// removed by extract-text-webpack-plugin
module.exports = {"OrderContainer":"Order__OrderContainer__16VKX","Ingredients":"Order__Ingredients__3K5e3","Ingredient":"Order__Ingredient__5aDVA","Wrapper":"Order__Wrapper__176jH","Overlay":"Order__Overlay__geEET","Details":"Order__Details__3YX_p","RowDivider":"Order__RowDivider__3LVfp","Title":"Order__Title__29hor","Content":"Order__Content__j4Osp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/Order.css
// module id = 162
// module chunks = 0